export function trackEvent(eventName) {
  if (typeof window.umami !== 'undefined') {
    window.umami.track(eventName);
  }
}


export function filterText(str) {
    if (typeof str !== 'string') return '';
    return str.replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g, '_');
}